// ** Styles
import "@styles/base/pages/page-misc.scss";

import { Button } from "reactstrap";
import { Component } from "react";
import Flex from "@components/ui-components/flex";
import ImageWrapper from "@components/ui-components/image-wrapper";
import axios from "axios";
import { setItemToStore } from "@helpers/utils";
// ** ThemeConfig
import themeConfig from "@configs/theme-config";

class ErrorBoundary extends Component {
    constructor (props) {
        super(props);
        this.state = {
            hasError      : false,
            chunkLoadError: false
        };
    }

    componentDidCatch (error, info) {
        if (
            error?.message?.includes("Failed to fetch dynamically imported module")
        ) {
            // Force a reload when a chunk fails to load
            this.setState({ chunkLoadError: true });
        }
        this.setState({ error, info, hasError: true });
    }

    render () {
        const { hasError, chunkLoadError } = this.state;
        const { children } = this.props;
        const {
            app: { logo }
        } = themeConfig;

        const updateAppVersion = async () => {
            const response =  await axios.get(`/dist/version.txt?${Date.now()}`);
            const currentVersion = new Date(response.headers?.["last-modified"]).valueOf();
            setItemToStore("appVersion", currentVersion);
            // window.location.reload();
        };

        const handleErrorClick = () => {
            window.location.href = "/";
        };
        
        return hasError ? (
            <div className="misc-wrapper flex-column">
                {window.navigator.onLine && (
                    <span className="brand-logo">
                        <ImageWrapper src={logo} alt="logo" id="brand-logo" />
                    </span>
                )}
                <div className="misc-inner p-2 p-sm-3 text-center">
                    <div className="w-100 text-center">
                        {window.navigator.onLine ? (
                            <ImageWrapper
                                id="error-img"
                                src={
                                    chunkLoadError ? "pages/new-version.svg" : "common/error.png"
                                }
                                alt="error"/>
                        ) : (
                            "Warning! No internet connection. Please check your internet connection and try again."
                        )}
                    </div>
                    <h4 className="mt-2">
                        {/* {error} */}
                        {chunkLoadError ? (
                            <>
                                {" "}
                                A new version of ${themeConfig.app.name} is available. Please click on 'Refresh' to apply the changes.
                            </>
                        ) : (
                            <>
                                Try refreshing the page, or going back and attempting the action again. If this problem persists,contact us.
                            </>
                        )}
                    </h4>

                    <Flex align="center" className="mt-2" justify="center">
                        <Button
                            onClick={() => handleErrorClick()}
                            color="info"
                            className="btn-sm-block">
                                Back to home
                        </Button>
                        <Button
                            onClick={() => updateAppVersion()}
                            color="primary"
                            className="btn-sm-block">
                            {chunkLoadError ? "Refresh" : "Try Again !"}
                        </Button>
                    </Flex>
                    
                </div>
            </div>
        ) : (
            children
        );
    }
}

export default ErrorBoundary;
